import Card from '@material-ui/core/Card';
import * as React from 'react';
import { stylesheet } from "typestyle";
import LoggerBox from './LoggerBox';
import { Cage } from './Models';

const css = stylesheet({
	cageName: {
		fontSize: '1.2em',
	},
	card: {
		margin: '5px',
		marginTop: '8px',
		padding: '3px',
	},
	locationName: {
		fontSize: '.6em',
		opacity: .5,
	},
	loggerBoxRow: {
		display: 'inline-flex',
		flexDirection: 'row',
		marginTop: '5px',
	},
})

export default class CageBox extends React.Component<{
	cage: Cage,
	oxygenMinimum: number,
}>{
	render() {
		const { cage, oxygenMinimum } = this.props;
		return (
			<Card className={css.card}>
				<div className={css.locationName}>{cage.location}</div>
				<div className={css.cageName}>{cage.name}</div>
				<div className={css.loggerBoxRow}>
					{cage.loggers.map(logger => <LoggerBox oxygenMinimum={oxygenMinimum} logger={logger} key={logger.id} />)}
				</div>
			</Card>
		);
	}
}


// WEBPACK FOOTER //
// ./src/CageBox.tsx